import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

import "../UserList.css";

export default function UsersList() {

  const [users, setUsers] = useState([]);

  useEffect(() => {
    async function fetchUsers() {
      const snapshot = await getDocs(collection(db, "publicUsers"));

      const usersData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setUsers(usersData);
    }

    fetchUsers();
  }, []);

  return (
    <div className="users-list">
      {users.map(user => (
        <div key={user.id} className="user-row">
          @{user.username}
        </div>
      ))}
    </div>
  );
}
